import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { UserTokenURL } from '../../../services/ApiHIS';
import Loading from '../../Loading';
import { postProcedimientosNoOperaciones } from '../../../services/Contratacion';
import ModalCrearProcedimientosNoOperacionales from './ModalCrearProcedimientosNoOperacionales';
import ModalModifcarProcedimientosNoOperacionales from './ModalModifcarProcedimientosNoOperacionales';
import ModalConsultarProcedimientosNoOperacionales from './ModalConsultarProcedimientosNoOperacionales';
import ModalEliminarProcedimientosNoOperacionales from './ModalEliminarProcedimientosNoOperacionales';


const ProcedimientosNoOperacionales = () => {
    const [loading, setloading] = useState(false);
    const [dataProcedimientosNoOperacionales, setdataProcedimientosNoOperacionales] = useState([]);
    const [modalOnCrearProcedimientosNoOperacionales, setmodalOnCrearProcedimientosNoOperacionales] = useState(false);
    const [actualizarDataProcedimientosNoOperacionales, setactualizarDataProcedimientosNoOperacionales] = useState('');
    const [dataUnProcedimientoNoOperacional, setdataUnProcedimientoNoOperacional] = useState({});
    const [modalOnModificarProcedimientosNoOperacionales, setmodalOnModificarProcedimientosNoOperacionales] = useState(false);
    const [modalOnConsultarProcedimientosNoOperacionales, setmodalOnConsultarProcedimientosNoOperacionales] = useState(false);
    const [modalOnEliminarProcedimientosNoOperacionales, setmodalOnEliminarProcedimientosNoOperacionales] = useState(false);
    let query = new URLSearchParams(useLocation().search);
    let tokenCons = JSON.parse(query.get('token'));
    let location = useLocation();
    useEffect(() => {
        // Google Analytics
        localStorage.setItem('tokenReact',tokenCons)
    }, [location]);

        //token
    useEffect(()=>{
        //console.log(tokenCons,'tokenConstokenCons')
        const url = UserTokenURL() 

        // Configurar la cabecera con el token JWT
        const headers = {
        Authorization: `Bearer ${tokenCons}`,
        };

        // Realiza la petición con Axios
        axios.get(url, { headers })
        .then(response => {
        //console.log(response.data.user_data, 'data user');

        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
        //console.log(usuarioInfo, 'usuarioInfoStr confirmado')

        // Resto del código...
        })
        .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
        });
    },[])

    useEffect(() => {
        setloading(false)
        postProcedimientosNoOperaciones().then((response) => {
            setdataProcedimientosNoOperacionales(response.data.data)
            setloading(true)
        })
    },[actualizarDataProcedimientosNoOperacionales])

    const handleOnclickCrear = () => {
        setmodalOnCrearProcedimientosNoOperacionales(true)
    }

    const handleOnclickBuscar = (e) => {
        e.preventDefault()
        const procedimiento = {
            "PRCODI": e.target.codigo.value,
            "PrNomb": e.target.descripcion.value
        }
        setloading(false)
        postProcedimientosNoOperaciones(procedimiento).then((response) => {
            setdataProcedimientosNoOperacionales(response.data.data)
            setloading(true)
        })
    }

    const handleOnclickModificar = (item) => {
        console.log(item, 'modificar')
        setdataUnProcedimientoNoOperacional(item)
        setmodalOnModificarProcedimientosNoOperacionales(true)
    }

    const handleOnclickConsultar = (item) => {
        console.log(item, 'consultar')
        setdataUnProcedimientoNoOperacional(item)
        setmodalOnConsultarProcedimientosNoOperacionales(true)
    }

    const handleOnclickEliminar = (item) => {
        console.log(item, 'eliminar')
        setdataUnProcedimientoNoOperacional(item)
        setmodalOnEliminarProcedimientosNoOperacionales(true)
    }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
          Procedimientos No Operacionales
        </div>

        <form onSubmit={handleOnclickBuscar}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Codigo
              </label>
              <div className="flex">
                <input
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="mb-3 xl:w-96 px-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Descripción
              </label>
              <div className="flex">
                <input
                  name="descripcion"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-6 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form >
        <div className="flex ">
          
        <button
        onClick={handleOnclickCrear}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >                        
                      </th>                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Codigo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Estado?
                      </th>
                      
                                       
                    </tr>
                  </thead>
                  <tbody >
                  {loading ? (
                    dataProcedimientosNoOperacionales.map((item,index)=>(                      
                      <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2">
                          <div className="flex flex-row flex-nowrap items-center">
                            <button className="mx-2" title="Editar" onClick={() => handleOnclickModificar(item)}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                <circle cx="12" cy="12" r="12" fill="#2196F3" />
                                <path d="M7.75 15.5v-1.92l5.61-5.61 1.92 1.92-5.61 5.61H7.75zm7.88-6.27l-1.92-1.92 1.06-1.06a.75.75 0 011.06 0l.92.92a.75.75 0 010 1.06l-1.06 1.06z" fill="#FFF"/>
                              </svg>
                            </button>

                            <button className="mx-2" title="Consultar" onClick={() => handleOnclickConsultar(item)}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                <circle cx="12" cy="12" r="12" fill="#4CAF50" />
                                <path d="M10.5 5a5.5 5.5 0 014.36 8.91l3.32 3.32a.75.75 0 01-1.06 1.06l-3.32-3.32A5.5 5.5 0 1110.5 5zm0 1.5a4 4 0 100 8 4 4 0 000-8z" fill="#FFF"/>
                              </svg>
                            </button>

                            <button className="mx-2" title="Eliminar" onClick={() => handleOnclickEliminar(item)}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
                                <circle cx="12" cy="12" r="12" fill="#F44336" />
                                <path d="M15.5 8.5H8.5v9a1 1 0 001 1h5a1 1 0 001-1v-9zM10 18v-7h1v7h-1zm3 0v-7h1v7h-1zM9 6.5V6h6v.5h3v1H6v-1h3z" fill="#FFF"/>
                              </svg>
                            </button>
                          </div>
                        </td>

                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">                          
                          {item.PRCODI}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
                        {item.PrNomb}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">                            
                            <div className="topping">
                                    <input
                                        type="checkbox"
                                        checked={item.PrSta === 'S'}
                                    />                          
                            </div> 
                        </td>
                        
                        
                      </tr> 
                    ))                   
                  ) : (                    
                      <tr className="divide-y divide-slate-700 ">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <Loading />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                  )}
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnCrearProcedimientosNoOperacionales && <ModalCrearProcedimientosNoOperacionales setmodalOnCrearProcedimientosNoOperacionales={setmodalOnCrearProcedimientosNoOperacionales} setactualizarDataProcedimientosNoOperacionales={setactualizarDataProcedimientosNoOperacionales}/>}
      {modalOnModificarProcedimientosNoOperacionales && <ModalModifcarProcedimientosNoOperacionales setmodalOnModificarProcedimientosNoOperacionales={setmodalOnModificarProcedimientosNoOperacionales} dataUnProcedimientoNoOperacional={dataUnProcedimientoNoOperacional} setactualizarDataProcedimientosNoOperacionales={setactualizarDataProcedimientosNoOperacionales}/>}
      {modalOnConsultarProcedimientosNoOperacionales? <ModalConsultarProcedimientosNoOperacionales setmodalOnConsultarProcedimientosNoOperacionales={setmodalOnConsultarProcedimientosNoOperacionales} dataUnProcedimientoNoOperacional={dataUnProcedimientoNoOperacional}/>:null}
      {modalOnEliminarProcedimientosNoOperacionales && <ModalEliminarProcedimientosNoOperacionales setmodalOnEliminarProcedimientosNoOperacionales={setmodalOnEliminarProcedimientosNoOperacionales} dataUnProcedimientoNoOperacional={dataUnProcedimientoNoOperacional} setactualizarDataProcedimientosNoOperacionales={setactualizarDataProcedimientosNoOperacionales}/>}
    </>
  )
}

export default ProcedimientosNoOperacionales